module.exports = __webpack_public_path__ + "static/nanogirlPodcast-d3a63682e5f71baeb5f39ff5594e63b8.jpg";